import { Box } from "@eworkit/iris";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";

import { HttpError } from "@/browser";
import { Header as ModalHeader } from "@/components/Header";
import { emailConfirmation } from "@/data/session";
import { Flex, Header, Img, Text } from "@/eworkitComponents";
import { RouteButton, withRouteProps } from "@/infrastructure/Route";
import { AnimatedLayoutContainer } from "@/views/components/Layout";
import { router } from "@/views/router";

import EmailConfirmedImg from "./email-confirmed.svg";
import { transformEmailConfirmationRouteProps } from "./selectors";
import { IEmailConfirmationRouteProps } from "./types";

interface Props extends IEmailConfirmationRouteProps, WithTranslation {}

interface State {
  confirmed?: boolean;
  error?: HttpError;
  email?: string;
}

class SessionEmailConfirmationComponent extends React.PureComponent<Props, State> {
  readonly state: State = {};

  async componentDidMount() {
    try {
      const { token } = this.props.routeProps;
      const { email } = await emailConfirmation({}, { token });
      this.setState({ confirmed: true, email });
    } catch (error) {
      this.setState({ error });
    }
  }

  renderError() {
    const { t } = this.props;

    return (
      <Flex margin={["xl"]} innerMargin="md" direction="column" align="center">
        <Header size="sm" align="center">
          {t("SESSION_EMAIL_CONFIRMATION.EXPIRED_HEADER")}
        </Header>
        <div>
          <Flex margin={["xl", false, false, false]} direction="column" innerMargin="md">
            <RouteButton
              variant="secondary"
              path={router.get("login").path}
              testName={router.get("login").name}
              size="lg">
              <Text>{t("SESSION_EMAIL_CONFIRMATION.BUTTON_LOGIN")}</Text>
            </RouteButton>
          </Flex>
        </div>
      </Flex>
    );
  }

  renderConfirmed() {
    const { t } = this.props;

    return (
      <Box pt="lg">
        <Flex direction="column" align="center" innerMargin="lg" padding={[false, "lg"]}>
          <ModalHeader size="lg" weight="bold" color="black" align="center">
            {t("SESSION_EMAIL_CONFIRMATION.VERIFIED_HEADER")}
          </ModalHeader>
          <Img src={EmailConfirmedImg} />
          <Header size="sm" align="center">
            <div>{t("SESSION_EMAIL_CONFIRMATION.TEXT_LINE_1")}</div>
            <div>{t("SESSION_EMAIL_CONFIRMATION.TEXT_LINE_2")}</div>
          </Header>
          <div>
            <Flex direction="column">
              <RouteButton
                variant="primary"
                path={router.get("login").path}
                state={{ email: this.state.email }}
                testName={router.get("login").name}
                size="lg">
                <Text>{t("SESSION_EMAIL_CONFIRMATION.BUTTON_LOGIN")}</Text>
              </RouteButton>
            </Flex>
          </div>
        </Flex>
      </Box>
    );
  }

  renderInner() {
    const { confirmed, error } = this.state;

    if (error) {
      return this.renderError();
    }

    if (confirmed) {
      return this.renderConfirmed();
    }

    return null;
  }

  render() {
    const { confirmed, error } = this.state;

    if (!confirmed && !error) {
      return null;
    }

    return (
      <>
        <AnimatedLayoutContainer size="sm" showLogo>
          {this.renderInner()}
        </AnimatedLayoutContainer>
      </>
    );
  }
}

export const SessionEmailConfirmation = withRouteProps(
  withTranslation("public")(SessionEmailConfirmationComponent),
  transformEmailConfirmationRouteProps,
);
